import { Action, State, StateContext } from '@ngxs/store'
import { Injectable } from '@angular/core'
import { UpdateTagEditorValidation, ClearTagEditorValidation } from '../actions/tag-editor-validation.actions'

export interface TagEditorValidationStateModel {
  readonly hasTags: boolean
  readonly isValid: boolean
  readonly lastUpdated: number
}

export type TagEditorValidationStateByClient = Record<number, TagEditorValidationStateModel>

@State<TagEditorValidationStateByClient>({
  name: 'tagEditorValidation',
  defaults: {},
})
@Injectable()
export class TagEditorValidationState {
  @Action(UpdateTagEditorValidation)
  updateTagEditorValidation(
    ctx: StateContext<TagEditorValidationStateByClient>,
    action: UpdateTagEditorValidation,
  ): void {
    const isValid = action.hasTags
    const currentState = ctx.getState()

    ctx.patchState({
      ...currentState,
      [action.clientId]: {
      hasTags: action.hasTags,
      isValid: isValid,
      lastUpdated: Date.now(),
      },
    })
  }

  @Action(ClearTagEditorValidation)
  clearTagEditorValidation(
    ctx: StateContext<TagEditorValidationStateByClient>,
    action: ClearTagEditorValidation,
  ): void {
    const currentState = ctx.getState()
    const { [action.clientId]: removed, ...rest } = currentState
    ctx.setState(rest)
  }
}
